export default {
  singleLabel: "Paramètre",
  storeNamespace: 'myaxiloc_setting',
  authFeature: 'myaxiloc-setting',
  listRouteName: "MyaxilocSettingList",
  newRouteName: null,
  editRouteName: "MyaxilocSettingEdit",
  useEditModal: true,
  formComponentName: 'MyaxilocSettingForm',
  hideActionNewButton: true,
  hideActionDeleteButton: true,
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'setting',
  sortBy: 'setting',
  showExtendedFilters: true,
  fields: [{
      name: 'setting',
      label: "Paramètre",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'context_slug',
      label: "Type",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: false,
      extendedFilter: true,
      inDetail: true,
      formatter: (context, value) => value ? context.$store.getters['myaxiloc_setting/getType'](value) ? context.$store.getters['myaxiloc_setting/getType'](value).text : null : null
    },
    {
      name: 'value',
      label: "Valeur",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/MyaxilocSetting/config.js